import React, { useState, useEffect } from "react";
import CustomButton from "../../../components/AddButton";
import { edit, Plus, map, placeMareker } from "../../../common/svg";
import { TripDetails } from "../../../common/staticData";
import CustomCard from "../../../components/Card";
// import Carousel from "../../../components/Carousel/index"
import DaysLeftCounter from "../../../components/DaysProgress";
import CustomChip from "../../../components/Chip";
import SecureImage from "../../../components/BucketImage/Image";
import DeliveryTimeline from "../../../components/DeliveryTimeline";
import { ApiService } from "../../../service/api.service";
import { OPERTIONS_URL } from "../../../common/common";
import moment from "moment";
import { useLiveTracking } from "../../../hooks/useLiveTracking";
// OLD MAP COMPONENT - COMMENTED OUT
// import SimpleLiveTrackingMap from "../../../components/LiveTracking/LiveTrackingMap";
// NEW MAP COMPONENT - SIMPLIFIED VERSION
import SimpleTripMap from "../../../components/TripMap/SimpleTripMap";
import { MASTER_URL } from "../../../common/common";
interface RoutesProps {
  id: any;
  tripData?: any;
  vehicleAssignments?: any[];
}

interface RouteDetail {
  routeId: string;
  pickupPoint: string;
  loadingPoint: string;
  unloadingPoint: string;
  clearancePoint: string;
  pickupAt: string;
  loadingAt: string;
  unloadingAt: string;
  clearanceAt: string;
  distanceKm: number;
  // Add other properties as needed
}

interface TripData {
  tripDetail: {
    tripId: string;
    bookingId: string;
    tripName: string;
    startingDateTime: string;
    tripNumber: string;
    daysLeft: number;
    routes: Array<{
      tripId: string;
      routeDetails: RouteDetail;
    }>;
  };
}

const Routes = ({ id, tripData: propTripData, vehicleAssignments: propVehicleAssignments }: RoutesProps) => {
  const apiService = new ApiService();
  const [activeTripCard, setActiveTripCard] = useState<number | null>(null);
  const [viewTripDetails, setViewTripDetails] = useState<boolean>(false);
  const [isWhite, setIsWhite] = useState(false);
  const [tripData, setTripData] = useState<TripData[]>([]);
  const [vehicleDetails, setVehicleDetails] = useState<any>([]);

  // NEW STATE FOR TRACKING URL AND VEHICLE DATA
  const [trackingUrl, setTrackingUrl] = useState<string | undefined>(undefined);
  const [vehicleData, setVehicleData] = useState<any>(null);

  // MAP DISPLAY STATE - SAME AS TRIPS PAGE
  const [isBlurred, setIsBlurred] = useState(true);

  const {
    showMap,
    hasTrackingData,
    isLoading,
    error,
    startTracking,
    setFirstDataReceived,
    canShowMap,
    isInLoadingState
  } = useLiveTracking();

  useEffect(() => {
    const handleClick = () => setIsWhite(true);
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  const handleClick = () => {
    console.log("Button clicked!");
  };

  const handleViewDetails = (index: number) => {
    setActiveTripCard(index);
    setViewTripDetails(true);
  };

  const [isEditing, setIsEditing] = useState(false);
  const [routeInfo, setRouteInfo] = useState({
    code: "",
    start: "",
    end: "",
  });

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const parts = value.split(" – ");
    setRouteInfo({
      code: parts[0] || "",
      start: parts[1] || "",
      end: parts[2] || "",
    });
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    if (propTripData) {
      const tripDetail = propTripData?.tripDetail ?? propTripData?.trip_details ?? undefined;
      const routesArray = tripDetail?.routes ?? propTripData?.routes ?? [];

      const derived: TripData[] = Array.isArray(routesArray)
        ? routesArray.map((r: any) => ({
          tripDetail: {
            tripId: tripDetail?.tripId ?? propTripData?.tripId ?? id,
            bookingId: tripDetail?.bookingId ?? propTripData?.bookingId ?? "",
            tripName: tripDetail?.tripName ?? propTripData?.tripName ?? "",
            startingDateTime: tripDetail?.startingDateTime ?? propTripData?.startingDateTime ?? "",
            tripNumber: tripDetail?.tripNumber ?? propTripData?.tripNumber ?? "",
            daysLeft: tripDetail?.daysLeft ?? propTripData?.daysLeft ?? 0,
            routes: [
              {
                tripId: r?.tripId ?? tripDetail?.tripId ?? id,
                routeDetails: (r?.routeDetails ?? r ?? {}) as any,
              },
            ],
          },
        }))
        : [];

      setTripData(derived);

      // Seed editable route header from first route
      const first = derived?.[0]?.tripDetail?.routes?.[0]?.routeDetails as any;
      setRouteInfo({
        code: String(first?.routeId || "").toString(),
        start: first?.loadingPoint || first?.pickupPoint || "",
        end: first?.unloadingPoint || "",
      });
    } else {
      setTripData([]);
      setRouteInfo({ code: "", start: "", end: "" });
    }

    if (propVehicleAssignments) {
      setVehicleDetails(Array.isArray(propVehicleAssignments) ? propVehicleAssignments : []);
    } else {
      setVehicleDetails([]);
    }
  }, [propTripData, propVehicleAssignments, id]);

  // NEW: Fetch vehicle details with tracking URL from master data service
  useEffect(() => {
    const fetchVehicleDetails = async () => {
      if (vehicleDetails.length > 0) {
        const vehicleId = vehicleDetails[0]?.vehicleId;
        if (vehicleId) {
          console.log("🔍 Fetching vehicle details for vehicleId:", vehicleId);
          try {
            console.log("🔍 Making API call to:", `${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
            const vehicleResponse: any = await apiService.getApi(`${MASTER_URL}/vehicle/get-one-route?vehicleId=${vehicleId}`);
            console.log("🔍 Vehicle API response:", vehicleResponse);
            console.log("🔍 Vehicle API response status:", vehicleResponse?.status);
            console.log("🔍 Vehicle API response type:", typeof vehicleResponse?.status);

            if (vehicleResponse?.status === 200 || vehicleResponse?.status === "200") {
              console.log("🔍 Inside status 200 condition");
              console.log("🔍 Vehicle response body:", vehicleResponse.body);
              const vehicleTrackingUrl = vehicleResponse.body?.trackingUrl;
              console.log("🔍 Vehicle trackingUrl:", vehicleTrackingUrl);
              console.log("🔍 Vehicle trackingUrl type:", typeof vehicleTrackingUrl);
              setTrackingUrl(vehicleTrackingUrl);
              setVehicleData(vehicleResponse.body);
            } else {
              console.log("🔍 Vehicle API response status is not 200:", vehicleResponse?.status);
            }
          } catch (vehicleError) {
            console.error("❌ Error fetching vehicle details:", vehicleError);
          }
        }
      }
    };

    if (vehicleDetails.length > 0) {
      fetchVehicleDetails();
    }
  }, [vehicleDetails]);

  const ShowMap = async () => {
    try {
      console.log("🗺️ Showing map with SimpleTripMap component");
      setIsBlurred(false);

      // Try to start tracking if we have vehicle registration number, but don't block map display
      const vehicleRegNo = vehicleDetails?.[0]?.vechicleData?.vehicleRegNo;
      if (vehicleRegNo) {
        console.log("🚗 Starting tracking for vehicle:", vehicleRegNo);
        await startTracking(vehicleRegNo);
      } else {
        console.log("⚠️ No vehicle registration number found, but showing map anyway");
      }
    } catch (error) {
      console.error("❌ Error starting live tracking:", error);
      // Still show the map even if tracking fails
      setIsBlurred(false);
    }
  };

  // Utility to truncate text with ellipsis
  const truncateText = (text: string, maxLength: number) => {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };

  return (
    <div>
      <div className="bg-white p-2 mt-3 rounded-[20px]">
        <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
          <p className="text-[#282828] text-[16px] font-[600]">
            Route Points
          </p>
          <CustomButton label="" icon={Plus} onClick={handleClick} />
        </div>
        <br />
        <div className="flex gap-2 mt-">
          {/* Left */}
          <div>
            {tripData.length > 0 ? (
              tripData.map((trip, index) => (
                <CustomCard
                  key={index}
                  onClick={() => handleViewDetails(index)}
                  isActive={activeTripCard === index}
                  className="w-[400px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
                >
                  <div className="gap-[-1]">
                    {/* Top Section: Booking Name and Trip Status */}
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <p className="font-poppins text-[14px] ">
                          {truncateText(trip?.tripDetail?.routes?.[0]?.routeDetails?.loadingPoint, 10) || 'Loading Point'}
                          {' -'}
                          {truncateText(trip?.tripDetail?.routes?.[0]?.routeDetails?.unloadingPoint, 10) || 'Unloading Point'}
                        </p>
                        <br />
                        <CustomChip
                          text="Active"
                          textColor="#04D900"
                          borderColor="#04D900"
                        />
                      </div>
                      <p className="font-[400] text-[14px]">#0{index + 1}</p>
                    </div>
                    {/* Booking Details */}
                    <div className="flex justify-between">
                      <div className="leading-[18px] felx flex-col items-start">
                        {/* <span>{trip.tripDetail.bookingId}</span> */}
                        <span>{trip?.tripDetail?.routes?.[0]?.routeDetails?.pickupPoint ? 'Pickup to Drop' : ''}</span>
                        <span className="ml-5 font-[500]">
                          {trip?.tripDetail?.tripName || 'Trip Name'}
                        </span>
                        <p className="font-poppins font-normal italic text-[15px] mt-1">
                          {moment(trip.tripDetail.startingDateTime).format("DD MMMM YYYY, hh:mma")}
                        </p>
                      </div>
                      <div className="flex items-center flex-col justify-center">
                        <DaysLeftCounter totalDays={trip?.tripDetail?.daysLeft || 0} />
                        <p className="text-[14px] font-[400]">Days Running</p>

                      </div>
                    </div>

                    {/* Client Name with Conditional Styling */}
                    <div className="flex justify-between items-end">
                      <div className="flex flex-col leading-[15px]">
                        <p className="text-[14px]">Route Mode</p>
                        <p
                          className={`font-medium text-[14px] ${activeTripCard === index ? "text-[# ]" : "text-[# ]"
                            }`}
                        >
                          {trip?.tripDetail?.routes?.[0]?.routeDetails?.routeId || 'Route'}
                        </p>
                      </div>

                      <div className="leading-[15px]">
                        <p
                          className={`text-[14px] ml-4 font-[300] ${isWhite ? "" : ""
                            }`}
                        >
                          Total {trip?.tripDetail?.routes?.[0]?.routeDetails?.distanceKm || 0} Kms
                        </p>
                        <p className="text-[16px] ml-6 font-[600] flex items-center">
                          {trip?.tripDetail?.routes?.[0]?.routeDetails?.loadingPoint || ''}
                          <SecureImage
                            fileKey={placeMareker}
                            alt="Over Speed"
                            width="25px"
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </CustomCard>
              ))
            ) : null}
          </div>
          {viewTripDetails && (
            <div className="mt-[-20px] w-full border-l border-[#C1C1C1] border-dashed">
              {viewTripDetails && (
                <div className="flex flex-col w-full">
                  <div className="flex justify-between w-full p-2"></div>
                  <div className="p-2 flex flex-col gap-4">
                    <div className="flex items-center justify-between p-2 w-full">
                      <p className="text-gray-700 text-sm font-medium ml-6">
                        Route 1
                      </p>
                      <div className="border border-gray-300 rounded-lg px-4 py-2 w-[500px] h-[40px] mr-[230px]">
                        {isEditing ? (
                          <input
                            type="text"
                            name="route"
                            value={`${routeInfo.code} – ${routeInfo.start} – ${routeInfo.end}`}
                            onChange={handleInputChange}
                            onBlur={handleBlur}
                            className="text-black text-sm font-semibold w-full bg-transparent outline-none"
                            autoFocus
                          />
                        ) : (
                          <p className="text-black text-sm font-semibold">
                            <span className="font-bold">{routeInfo.code}</span>{" "}
                            –{" "}
                            <span className="font-medium">
                              {routeInfo.start}
                            </span>{" "}
                            –{" "}
                            <span className="font-medium">{routeInfo.end}</span>
                          </p>
                        )}
                      </div>
                      <CustomButton
                        label=""
                        icon={edit}
                        onClick={handleEditClick}
                      />
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="">
                      <DeliveryTimeline tripId={id} />
                    </div>
                    <div className="w-[400px] h-[500px] rounded-[20px] mt-6 overflow-hidden relative">
                      {/* MAP - UPDATED WITH SAME PATTERN AS TRIPS PAGE */}
                      {!isBlurred ? (
                        <div className="w-full h-full">
                          {/* NEW MAP COMPONENT - SIMPLIFIED VERSION */}
                          <SimpleTripMap
                            tripId={id}
                            showMap={true}
                            onMapReady={() => console.log("🗺️ Route map is ready")}
                            trackingUrl={trackingUrl}
                          />
                        </div>
                      ) : (
                        <div
                          className="w-full h-full bg-gray-100 flex items-center justify-center text-gray-500 text-2xl font-semibold cursor-pointer"
                          onClick={ShowMap}
                        >
                          Show Live Map
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Routes;